import { createEffect } from 'effector'
import { onError } from '@/app/routing/events'
import {
  getAccountValueLeaderboard,
  getBalanceLeaderboard,
  getGigiLeaderboard,
  getTotalTimeLeaderboard,
  getYourLeaderboardPosition,
} from './api'

import { GetLeaderboardParams } from './types'
import { LEADERBOARD_BATCH_SIZE } from '@/shared/constants'
import { merge } from 'effector'

const getYourLbPositionFx = createEffect(async (userToken: string) => {
  const yourLbPosition = getYourLeaderboardPosition(userToken)
  return yourLbPosition
})

const getLeaderBoardsFx = createEffect(async (userToken: string) => {
  const leaderboards = await Promise.all([
    getAccountValueLeaderboard(userToken, 1, LEADERBOARD_BATCH_SIZE),
    getTotalTimeLeaderboard(userToken, 1, LEADERBOARD_BATCH_SIZE),
    getBalanceLeaderboard(userToken, 1, LEADERBOARD_BATCH_SIZE),
    getGigiLeaderboard(userToken, 1, LEADERBOARD_BATCH_SIZE),
  ])
  return leaderboards
})

export const getGigiLeaderboardFx = createEffect(async (params: GetLeaderboardParams) => {
  return await getGigiLeaderboard(params.userToken, params.page, params.size)
})
export const getHoursLeaderboardFx = createEffect(async (params: GetLeaderboardParams) => {
  return await getTotalTimeLeaderboard(params.userToken, params.page, params.size)
})
export const getAssetsLeaderboardFx = createEffect(async (params: GetLeaderboardParams) => {
  return await getAccountValueLeaderboard(params.userToken, params.page, params.size)
})

// test

const allLeaderboardsFailed = merge([
  getGigiLeaderboardFx.failData,
  getHoursLeaderboardFx.failData,
  getAssetsLeaderboardFx.failData,
])

// test

allLeaderboardsFailed.watch(() => {
  onError()
})

export { getLeaderBoardsFx, getYourLbPositionFx }
